import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import CareProviderCloseDialog from "@/modules/care-provider/components/edit-care-provider/care-provider-close-dialog"
import { CareProvider } from "@/modules/care-provider/components/edit-care-provider/care-provider-practice-tab"
import { useCloseCareProviderPermanentlyMutation } from "@/modules/care-provider/components/edit-care-provider/services/useCloseCareProviderPermanentlyMutation"

type CareProviderCloseCardProps = {
  careProvider: CareProvider
  permanentlyClosed: boolean
  onCloseMutationCompleted: VoidFunction
}

const CareProviderCloseCard = ({
  careProvider,
  permanentlyClosed,
  onCloseMutationCompleted,
}: CareProviderCloseCardProps) => {
  const { t } = useTranslation()
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const [closeCareProvider] = useCloseCareProviderPermanentlyMutation()

  const handleDialogClose = () => setConfirmDialogOpen(false)

  const handleConfirm = () => {
    if (careProvider?.id)
      closeCareProvider({
        variables: {
          input: {
            careProviderId: careProvider.id,
          },
        },
        onCompleted: () => {
          handleDialogClose()
          onCloseMutationCompleted()
        },
      })
  }

  return (
    <div className="p-4">
      <h4 className="text-on-surface mb-3 text-base font-medium">
        {t("admin.careProviders.dialog.reportToClose.headline")}
      </h4>

      <div className="mt-4 flex w-full flex-wrap gap-4">
        <div className="text-body-sm text-caption text-on-surface-subdued text-xs">
          {t("admin.careProviders.dialog.reportToClose.message")}
        </div>

        <Button
          className="ml-auto"
          variant="danger"
          disabled={permanentlyClosed}
          onClick={() => setConfirmDialogOpen(true)}>
          {t("admin.careProviders.dialog.reportToClose.reportAsClosedButtonTitle")}
        </Button>
      </div>

      {careProvider && (
        <CareProviderCloseDialog
          careProvider={careProvider}
          open={confirmDialogOpen}
          onConfirm={handleConfirm}
          onDiscard={handleDialogClose}
        />
      )}
    </div>
  )
}

export default CareProviderCloseCard
